<template>
	<el-card :class="'main-info'">
		<InvinityLoanCalculatorModal ref="invinity_calculator_modal" :proposal="tmpProposal"/>
		<InvinitySummaryModal ref="invinity_summary_modal" :proposal="tmpProposal"/>
		<div slot="header" class="clearfix">
			<p v-html="approved_action_status"></p>
		</div>
		<b-row>
			<b-col cols="6" md="4">
				<div class="mb-3">
					<p>CCRIS Commitment</p>
					<h3 class="font-weight-600">RM{{ _gHlp.getValue(proposal,'summary_ccris_track.total_ccris_commitment',0)  | moneyFormatter }}</h3>
				</div>
				<div class="mb-3">
					<p>Other Settlement</p>
					<h3 class="font-weight-600">RM{{ _gHlp.getValue(proposal,'summary_ccris_track.total_other_settlement',0) | moneyFormatter }}</h3>
				</div>
			</b-col>
			<b-col cols="6" md="4">
				<div class="mb-3">
					<p>Pre-screening Credit Loan Eligibility</p>
					<!-- <p>Invinity Credit Loan <span class="text-muted text-xs">(5 years)</span></p> -->
					<!-- <small class="text-dark font-weight-bold bg-fintos d-inline p-2">WIP</small> -->
					<h3 class="font-weight-600">
							<p class="text-primary font-weight-400 d-block d-md-inline-block cursor-pointer" @click="$refs.invinity_calculator_modal.show()">Open Calculator</p>
					</h3>
				</div>
				<div class="mb-3">
					<p>Invinity Credit Settlement</p>
					<!-- <h3 class="font-weight-600" v-if="!_gHlp.isEmpty(proposal.psal_invinity_id)">RM{{ proposal.summary_ccris_track.total_inv_settlement | moneyFormatter }}</h3> -->
					<h3 class="font-weight-600">
							RM{{ _gHlp.getValue(currentInvSummary,'debt_console_amount',0) | moneyFormatter }}
							<p v-if="!_gHlp.isEmpty(currentInvSummary)" class="text-primary font-weight-400 mx-2 d-block d-md-inline-block cursor-pointer" @click="$refs.invinity_summary_modal.show()">view details</p>
							<small v-else><i>Pending Submit To LMS</i></small>
					</h3>
				</div>
			</b-col>
			<b-col cols="6" md="4">
				<div class="mb-3">
					<p>Swipe Card Amount</p>
					<h3 class="font-weight-600">RM{{ _gHlp.getValue(proposal,'summary_ccris_track.total_swipe_back_amount',0) | moneyFormatter }}</h3>
				</div>
				<div class="mb-3">
					<p>Merchant Settlement</p>
					<h3 class="font-weight-600">RM{{ _gHlp.getValue(proposal,'summary_ccris_track.total_merchant_settlement',0) | moneyFormatter }}</h3>
				</div>
			</b-col>
		</b-row>
	</el-card>
</template>
<script>
import { Card } from 'element-ui'
import InvinityLoanCalculatorModal from '@/views/InitialProposal/Modals/InvinityLoanCalculatorModal'
import InvinitySummaryModal from '@/views/InitialProposal/Modals/InvinitySummaryModal'
import { IP_STATUS_COLOR } from '@/assets/js/colors.js'
import _ from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'

export default {
	props: ['proposal'],
	components: {
		InvinityLoanCalculatorModal,
		InvinitySummaryModal,
		[Card.name]: Card,
	},
	data() {
		return {
			IP_STATUS_COLOR: IP_STATUS_COLOR,
			modals: {
				show_loan_calculator: false
			},
			tmpProposal:{}
		}
	},
	watch: {
		proposal: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.tmpProposal = newVal;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapState(useInvinityStore, ['currentInvSummary']),
		approved_action_status() {
			if (_gHlp.isEmpty(_gHlp.getValue(this.proposal,'latest_approval.detail'))) return "Proposal has been ";

			let actionDate = _gHlp.formatMomentDate(_gHlp.getValue(this.proposal,'latest_approval.detail.papv_created_date'));
			let targetUsers = '';
			let color_sts = this.IP_STATUS_COLOR[this.proposal.psal_main_status]
			if (!_gHlp.isEmpty(_gHlp.getValue(this.proposal,'latest_approval.next_action.pset_access_user_details'))) {
				let x = _.map(this.proposal.latest_approval.next_action.pset_access_user_details, 'name');
				if (!_gHlp.isEmpty(x)) {
					targetUsers = x.join(', ');
				}
			}

			if(this.proposal.invinity_commitments.length > 0 && ['pending_accept', 'accepted'].includes(this.proposal.psal_approval_code) && _gHlp.isEmpty(this.proposal.psal_invinity_id)){
				return " <span class='font-weight-600 text-warning'>This proposal not sync with LMS please resubmit for approval</span>";
			}

			if (['final_draft', 'draft'].includes(this.proposal.psal_approval_code)) {
				return "created by " + _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+this.proposal.psal_sub_status+"</span> ." ;
			} else if (['submit_to_ssa_mgr', 'submit_final_to_ssa_mgr'].includes(this.proposal.psal_approval_code)) {
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has submited proposal for approval to SSA Manager " + targetUsers + " at " + actionDate + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+this.proposal.psal_sub_status+"</span>";
			} else if (['reject_final_by_ssa_mgr', 'reject_by_ssa_mgr'].includes(this.proposal.psal_approval_code)) {
				return "SSA Manager " + _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has reject proposal at " + actionDate + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+this.proposal.psal_sub_status+"</span>";
			} else if (this.proposal.psal_approval_code == 'appeal_to_ssa_mgr') {
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has appeal proposal for approval to SSA Manager " + targetUsers + " at " + actionDate + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+this.proposal.psal_sub_status+"</span>";
			} else if (this.proposal.psal_approval_code == 'submit_to_credit_mgr') {
				// return "SSA Manager " + _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has approve proposal and submitted to Credit Manager " + targetUsers + " at " + actionDate + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+proposal.psal_sub_status+"</span>";
				return "Your Credit Loan Application has been submitted, <span class='font-weight-600' style='{ color: "+color_sts+" }'>pending approval status</span>";
			} else if (this.proposal.psal_approval_code == 'rejected_by_credit_mgr') {
				// return "Credit Manager " + _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has reject proposal at " + actionDate + " and current status is <span class='font-weight-600' style='{ color: "+color_sts+" }'>"+proposal.psal_sub_status+"</span>";
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + "( Credit Manager ) <br/> Credit loan letter offer has been <span class='font-weight-600' style='{ color: "+color_sts+" }'>Rejected</span>";
			} else if (this.proposal.psal_approval_code == 'appeal_to_credit_head') {
				// return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + " has appeal proposal for approval to Credit Head " + targetUsers + " at " + actionDate + " and current status is ";
				return "Your Credit Loan Application has been appealed, <span class='font-weight-600' style='{ color: "+color_sts+" }'>pending approval status</span>";
			} else if (this.proposal.psal_approval_code == 'pending_accept') {
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + "( Credit Manager / Head ) <br/> Credit loan letter offer has been <span class='font-weight-600' style='{ color: "+color_sts+" }'>Approved</span>";
			} else if (this.proposal.psal_approval_code == 'final_approved') {
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + "SSA Manager has been <span class='font-weight-600' style='{ color: "+color_sts+" }'>Approved</span>";
			} else {
				// return "Proposal has been ";
				return _gHlp.getValue(this.proposal,'latest_approval.detail.user.name','') + "( Credit Manager / Head ) <br/> Credit loan letter offer has been <span class='font-weight-600' style='{ color: "+color_sts+" }'>Approved</span>";
			}
		}
	}
}
</script>